import React from 'react';
import './CompanyStrategy.css';

function RiskComplianceSOP() {
  return (
    <div className="document-section">
      <h2>Risk and Compliance SOP</h2>
      <iframe
        src="/pdfs/nesim-risk-and-compliance-sops-final.pdf"
        title="Risk &amp; Compliance SOPs Final"
        width="100%"
        height="800px"
        style={{ border: 'none' }}
      ></iframe>
    </div>
  );
}

export default RiskComplianceSOP;
